import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";

const ConfirmationModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title = "Confirm Action", 
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary"
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="confirmation-modal">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold d-flex align-items-center gap-2">
          {confirmVariant === "danger" && <FaExclamationTriangle className="text-danger" />}
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-3">
        <p className="mb-0 text-muted" style={{ fontSize: "16px" }}>{message}</p>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="light" onClick={onHide} className="fw-semibold px-4 rounded-pill">
          {cancelText}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} className="fw-semibold px-4 rounded-pill">
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
